<div class="contenedorInt">
    <div class="contenedorIntHeader">
        <header class="FheaderInt" id="Hestadisticas">
            <div class="textHeader flx">
                <div class="dUno dmMedio"></div>
                <div class="dCincoM dtOcho dmOnce">
                    <h1>ESTADÍSTICAS</h1>
                    <p>
                        Fundación BEST en números. Se están otorgando <span style="font-weight: 700;">{{this.cifra | number}}</span> consultas al mes, en los consultorios que tenemos en todo el país ya que nuestro lema es <span style="font-weight: 700;">“Unidos Para Ayudar”</span>.
                    </p>
                </div>
                <div class="dCinco dtDos dmMedio"></div>
            </div>
        </header>
    </div>
<div class="contenedorIntSub">
    <div class="FcfrCst">
        <div class="FcfrCstInt dSieteM dtDiez dmDoce flx">
            <div class="dDiez dmOnce FcttAzul flx">
                <div class="dSeis dmSeis FcfrBllt">
                <a (click)="go()">
                    <img src="./assets/images/icon-consultorios.svg" alt="Consultas y consultorios">
                    <p class="FcifrasDatos">
                        CONSULTAS Y<br/>CONSULTORIOS
                    </p>
                </a>
                </div>
                <div class="dSeis dmSeis FcfrBllt">
                <a>
                    <img src="./assets/images/icon-consultasEstado.svg" alt="Consultas por estado">
                    <p class="FcifrasDatos">
                        CONSULTORIOS<br/>POR ESTADO
                    </p>
                </a>
                </div>
            </div>
        </div>
    </div>
    <div class="espacioDefault"></div>
    <div class="FcstXEdo dDiez dmOnce">
        <h2>CONSULTAS POR ESTADO<br/>
            <!--<span>Mes de febrero 2023</span>-->
            <span>Mes de {{this.month}} del {{this.year}}</span>
        </h2><br/>
        <div class="FcstXEdoTabs flx">
            <div class="dTres dmTresM Factivo" id="tabN"    [ngClass]="{'FnoActivoP':activo=='segundo' || activo=='tercero'}" (click)="activo='primero'">NORTE</div>
            <div class="dTres dmTresM FnoActivo" id="tabC"  [ngClass]="{'Factivo':activo=='segundo'}" (click)="activo='segundo'">CENTRO</div>
            <div class="dTres dmTresM FnoActivo" id="tabS"  [ngClass]="{'Factivo':activo=='tercero'}" (click)="activo='tercero'">SUR</div>
        </div>
        <div class="FcstXEdoTab"></div>
        <div class="FcstNorte FblqActivo flx" id="FcstNorte"  [ngClass]="{'FblqnoActivoP':activo=='segundo' || activo=='tercero'}">
            <div class="FcstNorteTrj dTres dtSeis dmDoce" *ngFor="let norte of nortes">
                <img src="{{norte.urlImagen}}" alt="{{norte.estado}}">
                <h4>{{norte.estado}}</h4>
                <p>CONSULTAS: <span>{{norte.consultas | number}}</span></p>
            </div>        
        </div>
        <div class="FcstCentro FblqnoActivo flx" id="FcstCentro"  [ngClass]="{'FblqActivo':activo=='segundo'}">
            <div class="FcstCentroTrj dTres dtSeis dmDoce" *ngFor="let centro of centros">
                <img src="{{centro.urlImagen}}" alt="{{centro.estado}}">
                <h4>{{centro.estado}}</h4>
                <p>CONSULTAS: <span>{{centro.consultas | number}}</span></p>
            </div>
        </div>
        <div class="FcstSur FblqnoActivo flx" id="FcstSur"  [ngClass]="{'FblqActivo':activo=='tercero'}">
            <div class="FcstSurTrj dTres dtSeis dmDoce" *ngFor="let sur of surs">
                <img src="{{sur.urlImagen}}" alt="{{sur.estado}}">
                <h4>{{sur.estado}}</h4>
                <p>CONSULTAS: <span>{{sur.consultas | number}}</span></p>
            </div>
        </div>
    </div>
</div>
</div>